import React from 'react';

import { Dropdown } from 'primereact/dropdown';
import { MultiSelect } from 'primereact/multiselect';

export default function DummyFilter() {
  return (
    <>
      <div className="me-2 filterbar-condition">
        <Dropdown options={[]} placeholder="Select Condition" className="w-100" disabled />
      </div>
      <div className="me-2 filterbar-value">
        <MultiSelect
          options={[]}
          filter
          className="input-shadow w-100"
          display="chip"
          placeholder="Select value"
          optionValue="practice_area_id"
          optionLabel="practice_area_name"
          disabled
        />
      </div>
    </>
  );
}
